import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { useQuery } from '@tanstack/react-query';

export const usePatientInfo = () => {
  const { appointment } = useSessionAppointment();
  const dispatch = useDispatch();
  const patientQuery = useQuery({
    queryKey: ['/referrers/patients/', appointment.clinician_user_guid, appointment.patient_user_guid],
    queryFn: () => dispatch(actions.getPatientDetails(appointment.clinician_user_guid, appointment.patient_user_guid)),
    select: (data) => data?.users?.[0]
  });

  return patientQuery;
};
